export const handleCardActions = (data, setKanbanFormated, kanbanId) => {
  try {
    console.info("Card action received:", { action: data.action });
    const { action } = data;

    // Função para atualizar os dados de um card
    const handleCardUpdate = (data, setKanbanFormated, kanbanId) => {
      try {
        console.info("Update card event received:", { data });
        const { cardId, card } = data;

        if (!cardId || !card) {
          console.error("Missing required card data for update");
          return;
        }

        setKanbanFormated(prevKanban => {
          try {
            if (!prevKanban) {
              console.warn("No kanban data available");
              return prevKanban;
            }

            const newKanban = JSON.parse(JSON.stringify(prevKanban));
            const formattedCardId = cardId.startsWith('card-') ? cardId : `card-${cardId}`;

            // Encontrar a coluna que contém o card
            let columnId = null;
            for (const colId of Object.keys(newKanban.columns || {})) {
              const column = newKanban.columns[colId];
              if (column?.cardIds?.includes(formattedCardId)) {
                columnId = colId;
                break;
              }
            }

            if (!columnId) {
              console.warn(`Card ${formattedCardId} not found in any column of kanban ${kanbanId}`);
              return prevKanban;
            }

            // Formatar o card recebido para o formato esperado pelo estado local
            const formattedCard = {
              id: formattedCardId,
              name: card.title || '',
              description: card?.description || '',
              tags: card?.tags || [],
              amount: card?.amount,
              order: card?.order,
              creator: card?.creator,
              createdAt: card?.createdAt,
              updatedAt: card?.updatedAt,
              kanbanPriorityLevel: card?.kanbanPriorityLevel,
              taskNumber: card?.taskNumber,
              assigned: card?.assigned || [],
              requester: card?.requester,
              tasks: card?.tasks || [],
            };

            // Atualizar o card no objeto global de cards
            if (newKanban.cards) {
              newKanban.cards[formattedCardId] = formattedCard;
            }

            // Atualizar o card no objeto de cards da coluna
            if (columnId && newKanban.columns[columnId].cards) {
              newKanban.columns[columnId].cards[formattedCardId] = formattedCard;
            }

            console.info(`Successfully updated card ${formattedCardId} in kanban ${kanbanId}`);
            return newKanban;

          } catch (error) {
            console.error("Error updating card data:", error);
            return prevKanban;
          }
        });
      } catch (error) {
        console.error("Error handling card update event:", error);
      }
    };

    // Função para transferir cards
    const handleCardTransfer = (data, setKanbanFormated, kanbanId) => {
      try {
        const { columnId, cardId, card } = data;

        setKanbanFormated(prevKanban => {
          try {
            if (!prevKanban) {
              console.warn("No kanban data available");
              return prevKanban;
            }

            const newKanban = JSON.parse(JSON.stringify(prevKanban));
            const formattedCardId = cardId.startsWith('card-') ? cardId : `card-${cardId}`;
            const targetColumnId = columnId.startsWith('column-') ? columnId : `column-${columnId}`;

            let sourceColumnId = null;
            for (const colId of Object.keys(newKanban.columns || {})) {
              const column = newKanban.columns[colId];
              if (column?.cardIds?.includes(formattedCardId)) {
                sourceColumnId = colId;
                break;
              }
            }

            if (data.kanbanId && data.kanbanId !== kanbanId) {
              console.info(`Card ${formattedCardId} is moving to kanban ${data.kanbanId}`);
              if (sourceColumnId) {
                newKanban.columns[sourceColumnId].cardIds =
                  newKanban.columns[sourceColumnId].cardIds.filter(id => id !== formattedCardId);
                if (newKanban.columns[sourceColumnId].cards?.[formattedCardId]) {
                  delete newKanban.columns[sourceColumnId].cards[formattedCardId];
                }
                if (newKanban.cards?.[formattedCardId]) {
                  delete newKanban.cards[formattedCardId];
                }
                if (newKanban.columns[sourceColumnId].pagination) {
                  // CORRIGIDO: Garantir que seja operação numérica
                  const currentCount = Number(newKanban.columns[sourceColumnId].pagination.count) || 0;
                  newKanban.columns[sourceColumnId].pagination.count = Math.max(0, currentCount - 1);
                }

                console.info(`Successfully removed card ${formattedCardId} from kanban ${kanbanId}`);
              }
            }
            else if (targetColumnId) {
              console.info(`Processing card ${formattedCardId} to column ${targetColumnId}`);
              if (!newKanban.columns?.[targetColumnId]) {
                console.error(`Target column ${targetColumnId} not found in kanban ${kanbanId}`);
                return prevKanban;
              }
              if (sourceColumnId === targetColumnId) {
                console.info("Card is already in the target column, no action needed");
                return prevKanban;
              }

              let cardData = null;
              if (card && Object.keys(card).length > 0) {
                console.info("Using card data from the event");
                // Formatar o card para o formato esperado pelo estado
                cardData = {
                  id: formattedCardId,
                  name: card.title || '',
                  description: card?.description || '',
                  tags: card?.tags || [],
                  amount: card?.amount,
                  order: card?.order,
                  creator: card?.creator,
                  createdAt: card?.createdAt,
                  updatedAt: card?.updatedAt,
                  kanbanPriorityLevel: card?.kanbanPriorityLevel,
                  taskNumber: card?.taskNumber,
                  assigned: card?.assigned || [],
                  requester: card?.requester,
                  tasks: card?.tasks || [],
                };
              }
              else if (newKanban.cards?.[formattedCardId]) {
                console.info("Using card data from global cards collection");
                cardData = JSON.parse(JSON.stringify(newKanban.cards[formattedCardId]));
              }
              else if (sourceColumnId && newKanban.columns[sourceColumnId]?.cards?.[formattedCardId]) {
                console.info("Using card data from source column's cards collection");
                cardData = JSON.parse(JSON.stringify(newKanban.columns[sourceColumnId].cards[formattedCardId]));
              }
              else {
                console.warn(`Creating minimal card data for ${formattedCardId}`);
                cardData = { id: formattedCardId };
              }

              if (!newKanban.columns[targetColumnId].cardIds) {
                newKanban.columns[targetColumnId].cardIds = [];
              }
              if (!newKanban.columns[targetColumnId].cards) {
                newKanban.columns[targetColumnId].cards = {};
              }

              newKanban.columns[targetColumnId].cardIds.unshift(formattedCardId);
              newKanban.columns[targetColumnId].cards[formattedCardId] = cardData;

              if (newKanban.cards) {
                newKanban.cards[formattedCardId] = cardData;
              }

              // CORRIGIDO: Incrementar contador numericamente
              if (newKanban.columns[targetColumnId].pagination) {
                const currentCount = Number(newKanban.columns[targetColumnId].pagination.count) || 0;
                newKanban.columns[targetColumnId].pagination.count = currentCount + 1;
                console.info(`Target column count updated: ${currentCount} + 1 = ${newKanban.columns[targetColumnId].pagination.count}`);
              }

              // CORRIGIDO: Decrementar contador numericamente na coluna de origem
              if (sourceColumnId) {
                newKanban.columns[sourceColumnId].cardIds = newKanban.columns[sourceColumnId].cardIds.filter(id => id !== formattedCardId);
                if (newKanban.columns[sourceColumnId].cards?.[formattedCardId]) {
                  delete newKanban.columns[sourceColumnId].cards[formattedCardId];
                }
                if (newKanban.columns[sourceColumnId].pagination) {
                  const currentCount = Number(newKanban.columns[sourceColumnId].pagination.count) || 0;
                  newKanban.columns[sourceColumnId].pagination.count = Math.max(0, currentCount - 1);
                  console.info(`Source column count updated: ${currentCount} - 1 = ${newKanban.columns[sourceColumnId].pagination.count}`);
                }
              }

              console.info(`Successfully processed card ${formattedCardId} in kanban ${kanbanId}`);
            }

            return newKanban;
          } catch (innerError) {
            console.error("Error updating kanban state:", innerError);
            return prevKanban;
          }
        });
      } catch (error) {
        console.error("Error handling card transfer event:", error);
      }
    };

    // Função para deletar cards
    const handleCardDelete = (data, setKanbanFormated) => {
      try {
        const { cardId } = data;

        setKanbanFormated(prevKanban => {
          if (!prevKanban) return prevKanban;

          try {
            const newKanban = JSON.parse(JSON.stringify(prevKanban));
            const formattedCardId = cardId.startsWith('card-') ? cardId : `card-${cardId}`;

            let sourceColumnId = null;
            for (const colId of Object.keys(newKanban.columns || {})) {
              const column = newKanban.columns[colId];
              if (column?.cardIds?.includes(formattedCardId)) {
                sourceColumnId = colId;
                break;
              }
            }

            if (sourceColumnId) {
              newKanban.columns[sourceColumnId].cardIds =
                newKanban.columns[sourceColumnId].cardIds.filter(id => id !== formattedCardId);

              if (newKanban.columns[sourceColumnId].cards?.[formattedCardId]) {
                delete newKanban.columns[sourceColumnId].cards[formattedCardId];
              }

              if (newKanban.cards?.[formattedCardId]) {
                delete newKanban.cards[formattedCardId];
              }

              // CORRIGIDO: Decrementar contador numericamente
              if (newKanban.columns[sourceColumnId].pagination) {
                const currentCount = Number(newKanban.columns[sourceColumnId].pagination.count) || 0;
                newKanban.columns[sourceColumnId].pagination.count = Math.max(0, currentCount - 1);
                console.info(`Column count after deletion: ${currentCount} - 1 = ${newKanban.columns[sourceColumnId].pagination.count}`);
              }
            }

            return newKanban;
          } catch (error) {
            console.error("Error processing card deletion:", error);
            return prevKanban;
          }
        });
      } catch (error) {
        console.error("Error handling card delete event:", error);
      }
    };

    switch (action) {
      case 'transfer':
        handleCardTransfer(data, setKanbanFormated, kanbanId);
        break;
      case 'delete':
        handleCardDelete(data, setKanbanFormated);
        break;
      case 'update':
        handleCardUpdate(data, setKanbanFormated, kanbanId);
        break;
      default:
        console.warn(`Unknown card action: ${action}`);
    }
  } catch (error) {
    console.error("Error handling card action:", error);
  }
};

export const handleColumnActions = (data, setKanbanFormated, kanbanId) => {
  try {
    console.info("Column action received:", { action: data.action });
    const { action } = data;

    // Função para atualizar os dados de uma coluna
    const handleColumnUpdate = (data, setKanbanFormated, kanbanId) => {
      try {
        console.info("Update column event received:", { data });
        const { columnId, column } = data;

        if (!columnId || !column) {
          console.error("Missing required column data for update");
          return;
        }

        setKanbanFormated(prevKanban => {
          try {
            if (!prevKanban) {
              console.warn("No kanban data available");
              return prevKanban;
            }

            const newKanban = JSON.parse(JSON.stringify(prevKanban));
            const formattedColumnId = columnId.startsWith('column-') ? columnId : `column-${columnId}`;

            // Verificar se a coluna existe
            if (!newKanban.columns?.[formattedColumnId]) {
              console.warn(`Column ${formattedColumnId} not found in kanban ${kanbanId}`);
              return prevKanban;
            }

            // Atualizar as propriedades da coluna mantendo os cards existentes
            newKanban.columns[formattedColumnId] = {
              ...newKanban.columns[formattedColumnId],
              id: formattedColumnId,
              title: column.title || newKanban.columns[formattedColumnId].title || '',
              // Usar position em vez de order para manter consistência com a estrutura original
              position: column.position ?? newKanban.columns[formattedColumnId].position,
              color: column?.color !== undefined ? column.color : newKanban.columns[formattedColumnId].color,
              hasStart: column?.hasStart !== undefined ? column.hasStart : newKanban.columns[formattedColumnId].hasStart,
              hasFinished: column?.hasFinished !== undefined ? column.hasFinished : newKanban.columns[formattedColumnId].hasFinished,
              hasConcluded: column?.hasConcluded !== undefined ? column.hasConcluded : newKanban.columns[formattedColumnId].hasConcluded,
              // Manter os cards e cardIds existentes
              cards: newKanban.columns[formattedColumnId].cards || {},
              cardIds: newKanban.columns[formattedColumnId].cardIds || [],
              // Manter a paginação existente
              pagination: newKanban.columns[formattedColumnId].pagination || {
                count: 0,
                hasMore: false,
                page: 1
              }
            };

            // Atualizar a ordenação das colunas se a posição foi alterada
            if (column.position !== undefined && newKanban.columnOrder) {
              // Garantir que a coluna está na lista de columnOrder
              if (!newKanban.columnOrder.includes(formattedColumnId)) {
                newKanban.columnOrder.push(formattedColumnId);
              }

              // Reordenar as colunas pelo campo position
              newKanban.columnOrder.sort((a, b) => {
                const positionA = newKanban.columns[a]?.position ?? 9999999;
                const positionB = newKanban.columns[b]?.position ?? 9999999;
                return positionA - positionB;
              });
            }

            console.info(`Successfully updated column ${formattedColumnId} in kanban ${kanbanId}`);
            return newKanban;
          } catch (error) {
            console.error("Error updating column data:", error);
            return prevKanban;
          }
        });
      } catch (error) {
        console.error("Error handling column update event:", error);
      }
    };

    // Função para deletar colunas
    const handleColumnDelete = (data, setKanbanFormated, kanbanId) => {
      try {
        const { columnId } = data;

        if (!columnId) {
          console.error("Missing required columnId for delete");
          return;
        }

        setKanbanFormated(prevKanban => {
          if (!prevKanban) return prevKanban;

          try {
            const newKanban = JSON.parse(JSON.stringify(prevKanban));
            const formattedColumnId = columnId.startsWith('column-') ? columnId : `column-${columnId}`;

            // Verificar se a coluna existe
            if (!newKanban.columns?.[formattedColumnId]) {
              console.warn(`Column ${formattedColumnId} not found in kanban ${kanbanId}`);
              return prevKanban;
            }

            // Obter todos os cardIds da coluna antes de excluí-la
            const cardIds = newKanban.columns[formattedColumnId].cardIds || [];

            // Remover os cards da coleção global se existir
            if (newKanban.cards) {
              cardIds.forEach(cardId => {
                if (newKanban.cards[cardId]) {
                  delete newKanban.cards[cardId];
                }
              });
            }

            // Remover a coluna do objeto de colunas
            delete newKanban.columns[formattedColumnId];

            // Remover a coluna da ordem de colunas
            if (newKanban.columnOrder) {
              newKanban.columnOrder = newKanban.columnOrder.filter(id => id !== formattedColumnId);
            }

            console.info(`Successfully deleted column ${formattedColumnId} from kanban ${kanbanId}`);
            return newKanban;
          } catch (error) {
            console.error("Error processing column deletion:", error);
            return prevKanban;
          }
        });
      } catch (error) {
        console.error("Error handling column delete event:", error);
      }
    };

    // Verificar a ação solicitada e executar a função correspondente
    switch (action) {
      case 'update':
        handleColumnUpdate(data, setKanbanFormated, kanbanId);
        break;
      case 'delete':
        handleColumnDelete(data, setKanbanFormated, kanbanId);
        break;
      default:
        console.warn(`Unknown column action: ${action}`);
    }
  } catch (error) {
    console.error("Error handling column action:", error);
  }
};